import { type ReactNode } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog';

import { Button, type ButtonVariants } from '../ui/button';

interface ConfirmationPopupProps {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmColor?: ButtonVariants['variant'];
  isLoading?: boolean;
  statusMessage?: string;
  statusType?: 'success' | 'error' | 'info' | 'warning';
}

const ConfirmationPopup = ({
  isOpen,
  title,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  confirmColor = 'destructive',
  isLoading = false,
  statusMessage,
  statusType = 'error',
}: ConfirmationPopupProps) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
    >
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        {children}
        {statusMessage && (
          <div className={`status ${statusType}`}>{statusMessage}</div> //TODO: add a status message component
        )}
        <DialogFooter>
          <Button type="button" onClick={onCancel} variant="ghost">
            {cancelText}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            variant={confirmColor}
            disabled={isLoading || !!statusMessage}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationPopup;
